import { Navigate } from "react-router-dom";
import AppSkeleton from "../AppSkeleton";
import { useCurrentUserData } from "../CurrentUserProvider";

export default function InmateHomeScreen() {
  const data = useCurrentUserData();
  if (data.loading) return <AppSkeleton />;
  // inmates who need to reset their password
  if (data?.me?.__typename === "Inmate" && data?.me?.enablePasswordReset) {
    const systemCode = data?.me?.facility?.system?.code;
    return <Navigate to={`/login/${systemCode}/reset-password`} />;
  }
  if (data?.me) return <Navigate to="/home" />;
  return <Navigate to="/login" />;
}
